<template>
    <div class="page payment">
      <h1>Make a Payment</h1>
      <p>Securely submit your payment online.</p>
    </div>
  </template>
  
  <script setup>
  </script>
  
  <style scoped>
  .page.payment {
    padding: 2rem;
  }
  </style>
  